export const extractFileName = (response: Response): string | undefined => {
  let fileName: string | undefined = undefined
  const contentDisposition = response.headers.get("Content-Disposition")
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="([^"]+)"/i) || contentDisposition.match(/filename=([^;]+)/i);
    if (match && match[1]) {
      fileName = match[1].trim();
    }
  }

  return fileName
}
